import { createLogger } from "../../utils";
import allSettled from "../../utils/all-settled";
import accessGeoClientV1 from "./geo-v1";
const logger = createLogger("Geoclient-shim");
async function getLocationCoordinates(timeout = 1000, cache = true) {
    logger.logInfo(`coordinates requested, trying GeoV1`);
    return accessGeoClientV1(timeout, cache, "getCoordinates");
}
async function getLocationApproximation(timeout = 1000, cache = true) {
    logger.logInfo(`approximation requested, trying GeoV1`);
    return accessGeoClientV1(timeout, cache, "getApproximation");
}
async function getLocation(timeout = 1000, cache = true) {
    const locResults = await allSettled([
        getLocationCoordinates(timeout, true),
        getLocationApproximation(timeout, true),
    ]);
    const geoObject = {
        meta: { resolvedAt: Date(), fromCache: cache },
        coordinates: locResults[0].status === "fulfilled" ? locResults[0].value : undefined,
        approximation: locResults[1].status === "fulfilled" ? locResults[1].value : undefined,
    };
    return geoObject;
}
export { getLocation };
//# sourceMappingURL=geo-client.js.map